export const selectMainContent = (state) => state.main.content || [];
export const selectIsLoading = (state) => state.main.isLoading;
